/** 
 * @file       Accounts.css
 * @author     Alex Huctwith <alex@kingsds.network>
 * @author     Kevin Yu <kevin@distributive.network>
 *
 * @date       April 2022
 *
 *             Style for the accountslist component
 */

 .accounts-page {
  #bank-operations-tab {
    margin: 0.85em 0 1em ;
  }

  @media only screen and (max-width: 1024px) {
    #bank-operations-tab {
      margin-top: calc(2rem - 4px);
    }
  }
}

.accounts-table-section {
  overflow: hidden;
  padding: 0 0 4px 4px; /* Allows the focus-ring to be visible on the buttons */
}

.accounts-table-container {
  overflow: auto;
}

.accounts-table {
  width: 100%;
  overflow: hidden;
  font-size: 0.95rem;
  font-variant-numeric: tabular-nums;
}

.accounts-table .dcc {
  color: var(--primary-hue-main);
}

.accounts-btns {
  margin-top: 2rem;
}

@media only screen and (max-width: 1600px) {
  .accounts-table {
    margin-top: 0;
  }
}

.accounts-table th,
.accounts-table td {
  padding-inline: 10px;
}

.accounts-table * {
  margin: 0;
  padding: 0;
}

.accounts-table thead {
  padding-bottom: 10em;
  height: 3em;
}

.accounts-table thead th {
  border-bottom: 1px solid;
  font-weight: lighter;
  vertical-align: bottom;
  padding-bottom: 6px;
}

.accounts-table thead h1 {
  margin: 0;
  font-weight: bold;
  font-size: inherit;
  color: #3a3a3a;
}

.sort-selected {
  font-weight: bold;
}

.accounts-table :is(td, th):nth-child(1) {
  width: 25%;
  text-align: left;
}

.accounts-table :is(td, th):nth-child(2) {
  text-align: left;
}

.accounts-table :is(td, th):nth-child(3) {
  text-align: right;
}

/* Conditionally bolds all of the columns if the selected header is being sorted */
.accounts-table thead:has(th:nth-child(1) div.sort-selected) ~ tbody td:nth-child(1) :is(button),
.accounts-table thead:has(th:nth-child(1) div.sort-selected) ~ tfoot td:nth-child(1),
.accounts-table thead:has(th:nth-child(2) div.sort-selected) ~ tbody td:nth-child(2) :is(button),
.accounts-table thead:has(th:nth-child(3) div.sort-selected) ~ tbody td:nth-child(3) :is(button),
.accounts-table thead:has(th:nth-child(3) div.sort-selected) ~ tfoot td:nth-child(3) {
  font-weight: bold;
}

.accounts-table :is(td, th):nth-child(4) {
  width: 45.6px;
  min-width: 3em;
  text-align: center;
}

.accounts-table td:nth-last-child(2) {
  text-align: right;
  font-variant: tabular-nums;
  color: var(--primary-hue-main);
}

.accounts-table .label {
  text-align: left;
  font-weight: bold;
}

.accounts-table .label h2 {
  margin: 0;
  font-size: 1.1em;
  font-weight: bold;
}

.accounts-table tr {
  border-bottom: 1px solid #e5e5e5;
  padding: 0;
  margin: 0;
  height: 2.5em;
}

.accounts-table tbody tr:last-child {
  border-top: 1px solid #e5e5e5;
  border-bottom: none;
}

.accounts-table tbody tr:nth-last-child(2) {
  border-bottom: none;
}

.accounts-table tfoot {
  background-color: #f5f5f5;
  border-top: 2px solid var(--content-hue-light);
  border-bottom: 2px solid var(--content-hue-light);
  height: 3em;
}

.totalCredits {
  width: 100%;
  padding: 0;
}

.accounts-table tr th:first-child,
.accounts-table tr td:first-child {
  padding-left: 0.5em;
}

.accounts-table thead th span {
  display: inline;
  padding-left: 3px;
  font-weight: lighter;
  color: var(--content-hue-light);
}

.accounts-table thead th span.ascending::after {
  content: "▲";
}

.accounts-table thead th span.descending::after {
  content: "▼";
}

.accounts-table thead th span.not-selected::after {
  content: "▼"; /* Prevent layout shift when hiding the sorting indicators. */
  visibility: hidden;
}

.accounts-table tr td:first-child span:hover,
.accounts-table tr td:nth-child(2) .text:hover {
  text-decoration: underline;
  cursor: pointer;
  color: var(--primary-hue-main);
}

.accounts-table th img {
  margin: 0 auto;
}


.accounts-table thead th button {
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  text-align: left;
}

.accounts-table thead th button div {
  display: flex;
  align-items: center;
}

.accounts-table thead th button div.sort-selected {
  font-size: inherit;
  color: var(--content-hue-dark);
}

@media only screen and (min-width: 664px) {
  .accounts-table thead th button div {
    white-space: nowrap;
  }
}

@media only screen and (max-width: 480px) {
  .buttonsFlex {
    justify-content: start;
  }

  .accounts-table :is(td, th):nth-child(1) {
    width: 25%;
  }
}

.accounts-table tbody tr:hover td {
  background-color: var(--content-hue-bg);
}
